import { render, staticRenderFns } from "./SvgPerson.vue?vue&type=template&id=12496046&"
import script from "./SvgPerson.vue?vue&type=script&lang=js&"
export * from "./SvgPerson.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports